import { clsx } from 'clsx';

import { ThumbsDownIcon, ThumbsUpIcon, TruckIcon } from '@/components/icons/my-numbers';

import cn from './styles.module.sass';

interface IInfoBlockProps {
    status: 'active' | 'inactive' | 'delivery';
}

export const InfoBlock = ({ status }: IInfoBlockProps) => {
    return (
        <div
            className={clsx(
                cn.container,
                status === 'active' && cn.active,
                status === 'inactive' && cn.inactive,
                status === 'delivery' && cn.delivery
            )}
        >
            {status === 'active' && (
                <>
                    <div className={cn.icon}>{ThumbsUpIcon}</div>
                    <h4>Активные</h4>
                    <p>Ты получаешь бонусы с этого номера</p>
                </>
            )}
            {status === 'inactive' && (
                <>
                    <div className={cn.icon}>{ThumbsDownIcon}</div>
                    <h4>Неактивные</h4>
                    <p>Напомни другу оплатить номер до 15 числа, чтобы получить бонусы</p>
                </>
            )}
            {status === 'delivery' && (
                <>
                    <div className={cn.icon}>{TruckIcon}</div>
                    <h4>Доставка</h4>
                    <p>После доставки номер будет активен</p>
                </>
            )}
        </div>
    );
};
